// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t38m","col":"styles_col__qoldY"};